<template>
  <div id="custSettingMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>客户</el-breadcrumb-item>
          <el-breadcrumb-item>客户设置</el-breadcrumb-item>
          <el-breadcrumb-item>客户运行设置管理</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-form :inline="true"
             label-width="80px"
             class="pageSearch">
      <el-row>
        <el-col :span="22">
          <el-form-item label="客户类型">
            <el-select v-model="pageSearch.fCustTypeID"
                       clearable
                       placeholder="请选择类型">
              <el-option v-for="item in custTypeIDList"
                         :key="item.value"
                         :label="item.label"
                         :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input placeholder="请输入客户编号/客户名称/软件名称"
                      v-model="pageSearch.searchKeyWord"
                      class="search">
              <!-- <i slot="prefix"
               class="el-input__icon el-icon-search"></i> -->
            </el-input>
          </el-form-item>
          <el-form-item label="所属分组::">
            <el-select v-model="pageSearch.fGrpID"
                       clearable
                       @change="loadOptions"
                       placeholder="请选择所属分组">
              <el-option v-for="item in groupList"
                         :key="item.fGrpID"
                         :label="item.fGrpName"
                         :value="item.fGrpID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="业务员::">
            <el-select v-model="pageSearch.fUsrID"
                       clearable
                       placeholder="请选择业务员">
              <el-option v-for="item in userList"
                         :key="item.fUsrID"
                         :label="item.fUsrName"
                         :value="item.fUsrID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary"
                       size="small"
                       icon="el-icon-search"
                       @click="init">查询</el-button>
          </el-form-item>
        </el-col>
        <!-- <el-col :span="2"
                class="searchRowAdd">
          <el-button type="primary"
                     size="small"
                     icon="el-icon-edit"
                     v-if="is_edit"
                     @click="handleAdd">新增客户
          </el-button>
        </el-col> -->
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24"
              style="height: 5px"></el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           label="序号"
                           align="right">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column label="客户类型"
                           width="80"
                           prop="fCustTypeID"
                           :formatter="formatType">
          </el-table-column>
          <el-table-column prop="fCustName"
                           label="客户名称">
          </el-table-column>
          <el-table-column prop="fGrpName"
                           label="所属分组">
          </el-table-column>
          <el-table-column prop="fUsrName"
                           label="业务员">
          </el-table-column>
          <el-table-column prop="fIsNet"
                           width="80px"
                           label="网络">
          </el-table-column>
          <el-table-column width="100"
                           label="上传时间">
            <template slot-scope="scope">
              <el-tooltip placement="left">
                <div slot="content"
                     v-html="'线下数据上传起始时间:'+scope.row.fStartUpTime"></div>
                <span>{{scope.row.fStartUpTime}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="IsWebIPAddr"
                           width="80"
                           label="自动升级">
          </el-table-column>
          <el-table-column prop="IsPayIPAddr"
                           width="80"
                           label="电子支付">
          </el-table-column>
          <el-table-column prop="IsImgIPAddr"
                           width="80"
                           label="图片上传">
          </el-table-column>
          <el-table-column width="80"
                           label="图片保留">
            <template slot-scope="scope">
              <el-tooltip placement="left">
                <div slot="content"
                     v-html="'图片保留:'+scope.row.fPicSvrDays+'天'"></div>
                <span>{{scope.row.fPicSvrDays}}天</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="IsLogIPAddr"
                           width="80"
                           label="日志上传">
          </el-table-column>
          <el-table-column prop="IsInvIPAddr"
                           width="80"
                           label="电子发票">
          </el-table-column>
          <el-table-column prop="fUpCurTimes"
                           width="80"
                           align="right"
                           label="在场数据">
            <template slot-scope="scope">
              <el-tooltip placement="left">
                <div slot="content"
                     v-html="'在场数据上传轮询频率:'+scope.row.fUpCurTimes"></div>
                <span>{{scope.row.fUpCurTimes}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column width="80"
                           align="right"
                           label="历史数据">
            <template slot-scope="scope">
              <el-tooltip placement="left">
                <div slot="content"
                     v-html="'历史数据上传轮询频率:'+scope.row.fUpHisTimes"></div>
                <span>{{scope.row.fUpHisTimes}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           align="center"
                           fixed="right"
                           width="160">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="success"
                         @click="handleInfo(scope.$index, scope.row)">查看</el-button>
              <el-button size="mini"
                         type="warning"
                         v-if="is_edit"
                         @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
              <!-- <el-button size="mini"
                         type="danger"
                         v-if="is_del"
                         @click="handleDelete(scope.$index, scope.row)">删除</el-button>
              <el-button size="mini"
                         type="info"
                         v-if="is_syn"
                         @click="synCust(scope.$index, scope.row)">上传</el-button> -->
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog :title="dialogTitle"
               top="7vh"
               width="43%"
               v-dialogDrag
               :visible.sync="dialogFormVisible">
      <el-form :model="cust"
               :rules="rules"
               ref="ruleForm"
               label-width="150px">
        <el-row style="margin-top: -15px;height: 40px">
          <el-col :span="24" style="height:42px">
            <el-form-item label="网络::"
                          prop="fIsNet">
              <el-radio-group v-model="cust.fIsNet"
                              :disabled="formDisabled">
                <el-radio label="1">有网络</el-radio>
                <el-radio label="0">无网络</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height:42px">
          <el-col :span="12" style="height:42px">
            <el-form-item label="自动升级::"
                          prop="IsWebIPAddr">
              <el-radio-group v-model="cust.IsWebIPAddr"
                              :disabled="formDisabled||(cust.fIsNet==='0')">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height:42px">
            <el-form-item label="日志上传::"
                          prop="IsLogIPAddr">
              <el-radio-group v-model="cust.IsLogIPAddr"
                              :disabled="formDisabled||(cust.fIsNet==='0')">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height:42px">
          <el-col :span="24" style="height:42px">
            <el-form-item label="电子支付::"
                          prop="fPayIPAddr">
              <el-select v-model="cust.fPayIPAddr"
                         :disabled="formDisabled||(cust.fIsNet==='0')"
                         placeholder="请选择支付方式">
                <el-option v-for="item in fPayIPAddrList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
              <!-- <el-radio-group v-model="cust.IsPayIPAddr"
                              :disabled="formDisabled||(cust.fIsNet==='0')">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height:52px;border: 2px solid #ccc;">
          <el-col :span="12" style="height:42px;margin-top:8px">
            <el-form-item label="电子发票::"
                          prop="IseInvIPAddr">
              <el-radio-group v-model="cust.IseInvIPAddr"
                              :disabled="formDisabled||(cust.fIsNet==='0')">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="3" v-if="cust.IseInvIPAddr" style="height: 42px;margin-top:8px">
            <el-form-item label-width="80px"
                              label=" ">
                  <el-checkbox v-model="cust.IsfeInvTmp"
                              :disabled="formDisabled">临停开票</el-checkbox>
                </el-form-item>
          </el-col>
          <el-col :span="3" v-if="cust.IseInvIPAddr" style="height: 42px;margin-top:8px">
            <el-form-item label-width="80px"
                              label=" ">
                  <el-checkbox v-model="cust.IsfeInvCard"
                              :disabled="formDisabled">包月车开票</el-checkbox>
                </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height:52px;border: 2px solid #ccc;;margin-top:10px">
          <el-col :span="12" style="height:42px;margin-top:8px">
            <el-form-item label="图片上传::"
                          prop="IsImgIPAddr">
              <el-radio-group v-model="cust.IsImgIPAddr"
                              :disabled="formDisabled||(cust.fIsNet==='0')">
                <el-radio :label="true">已开启</el-radio>
                <el-radio :label="false">未开启</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12"  style="height:42px;margin-top:8px"
                  v-if="cust.IsImgIPAddr">
            <el-form-item label="图片保留天数::"
                          prop="fPicSvrDays">
              <el-select v-model="cust.fPicSvrDays"
                         :disabled="formDisabled||(cust.fIsNet==='0')"
                         style="width:220px"
                         placeholder="请选择保留天数">
                <el-option v-for="item in picSvrDaysList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height:42px;margin-top:10px">
          <el-col :span="24" style="height:42px">
            <el-form-item label="数据上传起始时间::"
                          prop="fStartUpTime">
              <el-date-picker v-model="cust.fStartUpTime"
                              :disabled="formDisabled||(cust.fIsNet==='0')"
                              :clearable="false"
                              type="date"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row style="height:42px">
          <el-col :span="12" style="height:42px">
            <el-form-item label="在场数据上传轮询频率::"
                          prop="fUpCurTimes">
              <el-select v-model="cust.fUpCurTimes"
                         :disabled="formDisabled||(cust.fIsNet==='0')"
                         style="width:220px"
                         filterable
                         placeholder="在场数据上传轮询频率::">
                <el-option v-for="item in upCurTimesList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height:42px">
            <el-form-item label="历史数据上传轮询频率::"
                          label-width="160px"
                          prop="fUpHisTimes">
              <el-select v-model="cust.fUpHisTimes"
                         :disabled="formDisabled||(cust.fIsNet==='0')"
                         style="width:220px"
                         filterable
                         placeholder="历史数据上传轮询频率::">
                <el-option v-for="item in upHisTimesList"
                           :key="item.value"
                           :label="item.label"
                           :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

          <el-row style="height:42px">
          <el-col :span="12" style="height:42px">
            <el-form-item label="Mqtt1地址::"
                          prop="fMqttIPAddr1">
                <el-input v-model="cust.fMqttIPAddr1"
                         style="width:220px"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="height:42px">
            <el-form-item label="Mqtt2地址::"
                          label-width="160px"
                          prop="fMqttIPAddr2">
                <el-input v-model="cust.fMqttIPAddr2"
                         style="width:220px"
                        :disabled="true"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="dialog-footer"
           slot="footer">
        <el-button type="primary"
                   @click="submitForm('ruleForm')"
                   v-if="!formDisabled">保存</el-button>
        <el-button @click="dialogFormVisible = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { cust as api } from '../../api/cust'
import * as user from '../../api/user'
const delay = (function () {
  let timer = 0
  return function (callback, ms) {
    clearTimeout(timer)
    timer = setTimeout(callback, ms)
  }
})()
export default {
  data () {
    return {
      is_edit: false,
      formDisabled: false,
      tableHeight: 0,
      custTypeIDList: [{ value: '0', label: '封闭式场库' }, { value: '1', label: '路侧场库' }],
      picSvrDaysList: [{ value: '7', label: '7天' }, { value: '15', label: '15天' }, { value: '30', label: '30天' }, { value: '90', label: '90天' }, { value: '180', label: '180天' }, { value: '360', label: '360天' }],
      upCurTimesList: [{ value: '20', label: '20' }, { value: '40', label: '40' }, { value: '60', label: '60' }, { value: '90', label: '90' }, { value: '120', label: '120' }, { value: '150', label: '150' }, { value: '300', label: '300' }, { value: '720', label: '720' }],
      upHisTimesList: [{ value: '20', label: '20' }, { value: '30', label: '30' }, { value: '61', label: '61' }, { value: '91', label: '91' }, { value: '121', label: '121' }, { value: '151', label: '151' }, { value: '181', label: '181' }, { value: '241', label: '241' }, { value: '301', label: '301' }, { value: '361', label: '361' }, { value: '721', label: '721' }, { value: '3601', label: '3601' }],
      fPayIPAddrList: [],
      dialogFormVisible: false,
      fCustNoDisabled: false,
      fGrpDisabled: false,
      loading: true,
      dialogTitle: '',
      pageData: [],
      userList: [],
      groupList: [],
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustTypeID: '',
        fGrpID: '',
        fUsrID: '',
        searchKeyWord: ''
      },
      cust: {
        fCustID: '',
        fPicSvrDays: '7',
        fIsNet: '0',
        IsWebIPAddr: false,
        fPayIPAddr: '',
        IsImgIPAddr: false,
        IsLogIPAddr: false,
        IseInvIPAddr: false,
        IsfeInvTmp: false,
        IsfeInvCard: false,
        fUpCurTimes: '30',
        fUpHisTimes: '91',
        fStartUpTime: new Date()

      },
      rules: {

      }
    }
  },
  methods: {
    // 搜索词搜索
    wordSearch () {
      delay(() => {
        this.init()
      }, 1000)
    },
    init (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      this.loading = true
      api.custPageList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：加载客户信息失败')
          }
        }
      })
    },
    formatType (row, column, cellValue, index) {
      if (cellValue === '0') {
        return '封闭式'
      } else {
        return '路侧'
      }
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.init(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.init(val)
    },
    handleInfo (index, row) {
      this.tabModel = 'BaseInfo'
      this.dialogTitle = '【' + row.fCustName + '】查看客户运行设置'
      this.fGrpDisabled = true
      this.fCustNoDisabled = true
      this.formDisabled = true
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      api.custInfo(row.fCustID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            // 查看需要给默认值 ----需要给默认值
            if (data.Data.fPicSvrDays === '0') {
              data.Data.fPicSvrDays = ''
            }
            if (data.Data.fUpCurTimes === '0') {
              data.Data.fUpCurTimes = ''
            }
            if (data.Data.fUpHisTimes === '0') {
              data.Data.fUpHisTimes = ''
            }
            this.cust = data.Data
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    handleEdit (index, row) {
      this.tabModel = 'BaseInfo'
      this.dialogTitle = '【' + row.fCustName + '】编辑客户运行设置'
      this.fCustNoDisabled = false
      this.fGrpDisabled = false
      this.formDisabled = false
      if (row.park_num > 0) {
        this.fGrpDisabled = true
        this.fCustNoDisabled = true
      }
      if (this.$refs['ruleForm']) {
        this.$refs['ruleForm'].resetFields()
      }
      this.dialogFormVisible = true
      api.custInfo(row.fCustID).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            data.Data = data.Data || {}
            // 编辑----需要给默认值
            if ((data.Data.fPicSvrDays || '').trim().length <= 0 || data.Data.fPicSvrDays === '0') {
              data.Data.fPicSvrDays = '7'
            }
            if ((data.Data.fUpCurTimes || '').trim().length <= 0 || data.Data.fUpCurTimes === '0') {
              data.Data.fUpCurTimes = '30'
            }
            if ((data.Data.fUpHisTimes || '').trim().length <= 0 || data.Data.fUpHisTimes === '0') {
              data.Data.fUpHisTimes = '91'
            }
            if ((data.Data.fStartUpTime || '').trim().length <= 0) {
              data.Data.fStartUpTime = new Date()
            }
            this.cust = data.Data
          } else {
            this.$message.error(data.Msg)
          }
        }
      })
    },
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.formDisabled) { return }
          if (this.cust.fStartUpTime instanceof Date) {
            this.cust.fStartUpTime = this.$dateFormat(this.cust.fStartUpTime, 'yyyy-MM-dd')
          }
          api.custSvrEdit(this.cust).then(res => {
            if (res && res.data) {
              var data = res.data
              if (data.IsOk) {
                this.dialogFormVisible = false
                this.$message({
                  type: 'success',
                  message: data.Msg
                })
                this.init(this.pageSearch.pageIndex)
              } else {
                this.$message.error('提示：' + data.Msg)
              }
            }
          })
        }
      })
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 220
      obj.tableHeight = clientHeight
    },
    loadOptions (val) {
      this.pageSearch.fUsrID = ''
      this.userList = []
      api.allCustUser(val).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.userList = data.Data || []
          } else {
            this.$message.error('提示：加载业务员失败')
          }
        }
      })
    },
    loadGroups () {
      api.groupList().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.groupList = data.Data
          } else {
            this.$message.error('加载所属分组失败')
          }
        }
      })
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 41000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_edit = data.Data.data.is_edit
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
    this.loadGroups()
    api.custPayIPAddrList().then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          this.fPayIPAddrList = data.Data || []
        } else {
          this.$message.error('提示：加载电子支付地址信息失败')
        }
      }
    })
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>
<style>
/* dialog弹出框样式 */
#custSettingMain .el-dialog__headerbtn {
  top: 10px;
  font-size: 20px;
}
#custSettingMain .el-dialog__title {
  color: white;
}
#custSettingMain .el-dialog__header {
  background-color: #337ab7;
  padding: 10px;
}
#cuscustSettingMaintMain .el-dialog__body {
  padding: 0px;
}
#custSettingMain .is-disabled .el-input__inner,
#custSettingMain .is-disabled .el-textarea__inner {
  color: #606266;
}
#custSettingMain .el-dialog {
  min-width: 795px;
}
</style>
<style scoped>
.el-dropdown-link {
  cursor: pointer;
  color: #409eff;
}
.pageSearch .el-form-item {
  margin-bottom: 5px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 300px;
}
.searchRowAdd {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/view/cust/custSettingMain.vue